import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Heart } from 'lucide-react';
import { API_BASE_URL } from '../config';
import AnalystLeaderboard from '../components/analysts/AnalystLeaderboard';

function getAuthHeader() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default function AnalystFollowPage() {
  const [analysts, setAnalysts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // GET /api/research/analysts/?is_following=true
    // Backend must support this filter and return is_following: true per analyst
    axios
      .get(`${API_BASE_URL}/api/research/analysts/?is_following=true`, {
        headers: getAuthHeader(),
      })
      .then((res) => {
        const data = res.data;
        const list = data?.results ?? (Array.isArray(data) ? data : []);
        setAnalysts(list);
      })
      .catch(() => setAnalysts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-4 md:p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Following</h1>
        <p className="text-sm text-gray-500 mt-1">
          Analysts you follow — their new predictions will show up here.
        </p>
      </div>

      {!loading && analysts.length === 0 ? (
        <div className="text-center py-20 text-gray-400">
          <Heart size={44} className="mx-auto mb-4 opacity-20" />
          <p className="font-medium text-base">You're not following anyone yet.</p>
          <p className="text-sm mt-1">
            Go to the <span className="font-medium text-gray-600">Leaderboard</span> and tap the heart on any analyst to follow them.
          </p>
        </div>
      ) : (
        <AnalystLeaderboard analysts={analysts} loading={loading} showFollow />
      )}
    </div>
  );
}
